import Alpine from 'alpinejs';
import { msg } from '../main';
import { updateMiniCart, addToCart } from './cart';
import { scrollToElem } from './support';
import { INIT_stripe } from './stripe';

export const INIT_configurator = () => {
  // Session
  const configuratorSession = document.querySelector(
    'meta[name=configurator_session]'
  )
    ? JSON.parse(
        document.querySelector('meta[name=configurator_session]').content
      )
    : null;

  // Steps
  let step;
  let substep;

  if (window.location.search) {
    const app_url_params = new URLSearchParams(window.location.search);

    step = Number(app_url_params.get('step'));
    substep = Number(app_url_params.get('substep'));
  }

  window.Alpine = Alpine;

  // Store
  Alpine.store('configurator', {
    step: step || 1,
    substep: substep,
  });

  // Data
  Alpine.data('configurator', () => ({
    data: {
      tree: {
        step: {
          type: true,
          size: false,
          decor: false,
          battery: false,
          color: false,
          c_bespoke: false,
          presents: false,
          summary: false,
        },
        attributes: {
          type: { id: 0, name: '', slug: '' },
          size: { id: 0, name: '', slug: '' },
          decor: { id: 0, name: '', slug: '' },
          battery: { id: 0, name: '', slug: '' },
          color: { id: 0, name: '', slug: '' },
          c_bespoke: { id: [], name: [], slug: [] },
          presents: { id: 0, name: '', slug: '' },
        },
        step_3_prices: {
          undecorated: 0,
          lights_only: 0,
          decorated: 0,
          double_decorations: 0,
          ice_white: 0,
          warm_white: 0,
        },
        step_6_prices: {
          no_just_the_basic: 0,
          yes_add_decorative_presents: 0,
        },
        quantity: 1,
        subtotal: 0,
        total: 0,
        type: 'variation',
      },

      accessory: {
        step: {
          add: true,
          type: false,
          size: false,
          color: false,
          summary: false,
        },
        attributes: {
          add: { id: 0, name: '', slug: '' },
          type: { id: 0, name: '', slug: '' },
          size: { id: 0, name: '', slug: '' },
          color: { id: 0, name: '', slug: '' },
        },
        quantity: 1,
        subtotal: 0,
        total: 0,
        type: 'variation',
      },

      has_tree: 'No',
      has_little_tree: 'No',
      contract: configuratorSession.contract || 'No',
      pay_now: configuratorSession.pay || '',
      po_required: configuratorSession.po_required || '',
      billing_address: configuratorSession.billing_address || 'No',
      delivery_site_contact: configuratorSession.delivery_site_contact || 'No',
      unloading_address: configuratorSession.unloading_address || 'Yes',
      van_info: configuratorSession.van_info || 'No',
      premises_working_hours:
        configuratorSession.premises_working_hours || 'No',
      premises_weekend: configuratorSession.premises_weekend || 'No',
      tcs: [],
    },

    init() {
      if (
        this.$store.configurator.step === 3 &&
        this.$store.configurator.substep === 3
      ) {
        cartHasTrees(this.data);
      }

      this.$watch('$store.configurator.step', step => {
        if (step === 3 && this.$store.configurator.substep === 3) {
          cartHasTrees(this.data);
        }
        if (step === 4) {
          INIT_stripe();
        }
      });

      this.$watch('data.tree.attributes', attributes => {
        setPrice(this.data.tree, attributes);
      });

      this.$watch('data.tree.quantity', value => {
        const subtotal = this.data.tree.subtotal;

        if (subtotal) {
          const price = Number(subtotal.replace(/[^0-9.-]+/g, ''));
          const quantity = Number(value);

          this.data.tree.total = (price * quantity)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
      });

      this.$watch('data.accessory.attributes', attributes => {
        setPrice(this.data.accessory, attributes);
      });

      this.$watch('data.accessory.quantity', value => {
        const subtotal = this.data.accessory.subtotal;

        if (subtotal) {
          const price = Number(subtotal.replace(/[^0-9.-]+/g, ''));
          const quantity = Number(value);

          this.data.accessory.total = (price * quantity)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
      });

      window.addEventListener('click', event => {
        const target = event.target;

        // Configurator
        if (target.classList.contains('g-configurator--checkbox')) {
          const stepCurrent = target.dataset.stepCurrent;
          const activeSteps = target.dataset.activeSteps.split(',');

          let product = 'tree';

          target.blur();

          if (target.name.includes('accessory')) {
            product = 'accessory';
          }

          if (target.checked) {
            if (product === 'tree') {
              this.data[product].type = target.dataset.type || 'variation';

              if (this.data[product].type === 'simple') {
                this.data[product].subtotal = target.dataset.price;
              }
            }

            setSteps(this.data[product].step, activeSteps);
            setAttribute(target, this.data[product].attributes[stepCurrent]);
            resetAttribute(
              target,
              this.data[product].attributes,
              activeSteps.slice(0, -1)
            );

            // Little Tree (Type Variation)
            if (
              this.data[product].type === 'variation' &&
              target.classList.contains('g-configurator--checkbox') &&
              target.dataset.littleTree === '1'
            ) {
              this.data.tree.attributes.decor.slug = 'undecorated';
              this.data.tree.attributes.presents.slug = 'no-just-the-basic';
            }

            scrollToNextStep(
              target,
              `${product}-${activeSteps.slice(-1)}`,
              () => {
                // Step 6 prices
                if (
                  target.classList.contains('g-configurator--checkbox') &&
                  target.dataset.presents &&
                  this.data.tree.step.presents
                ) {
                  const app_url = document.querySelector('meta[name=app_url]')
                    ? document.querySelector('meta[name=app_url]').content
                    : null;
                  const presents = target.dataset.presents.split(',');

                  let attributes = [];

                  if (this.data.tree.attributes.decor) {
                    attributes.push({
                      'attribute_pa_decorations-lights':
                        this.data.tree.attributes.decor.slug ||
                        'not-applicable',
                    });
                  }
                  if (this.data.tree.attributes.battery) {
                    attributes.push({
                      attribute_pa_battery:
                        this.data.tree.attributes.battery.slug ||
                        'not-applicable',
                    });
                  }
                  if (this.data.tree.attributes.color) {
                    attributes.push({
                      attribute_pa_colour:
                        this.data.tree.attributes.color.slug ||
                        'not-applicable',
                    });
                  }

                  presents.forEach(attr => {
                    attributes.push({
                      'attribute_pa_decorative-presents': attr,
                    });

                    document.body.classList.add('is-loading');

                    fetch(`${app_url}/routes/variations`, {
                      method: 'POST',
                      mode: 'cors',
                      cache: 'no-cache',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      redirect: 'follow',
                      referrerPolicy: 'no-referrer',
                      body: JSON.stringify({
                        product_id: this.data.tree.attributes.size.id,
                        attributes: attributes,
                      }),
                    })
                      .then(response => response.json())
                      .then(data => {
                        this.data.tree.step_6_prices[
                          attr.replaceAll('-', '_')
                        ] = `£${new Intl.NumberFormat("en", { minimumFractionDigits: 2 }).format(data.variation_price)}`;

                        document.body.classList.remove('is-loading');
                      })
                      .catch(error => {
                        console.error('Error:', error);
                      });
                  });
                }
              }
            );
          } else {
            if (product === 'tree') {
              this.data[product].type == 'variation';
            }

            setSteps(this.data[product].step, activeSteps.slice(0, -1));
            resetAttribute(
              target,
              this.data[product].attributes,
              activeSteps.slice(0, -2)
            );
          }

          // Tree Preview
          if (product === 'tree') {
            const treePreview = document.getElementById('configurator-preview-tree');

            if (treePreview) {
              const previews = treePreview.dataset.previews;

              if (previews) {
                const arrPreviews = JSON.parse(previews);

                if (arrPreviews) {
                  const type = this.data[product].attributes.type.slug;
                  const decor = this.data[product].attributes.decor.slug;
                  const color = this.data[product].attributes.color.slug;
                  const presents = this.data[product].attributes.presents.slug;

                  let treeFileName = '';

                  if (type !== '') {
                    treeFileName += type;
                  }
                  if (decor !== '') {
                    treeFileName += '-' + decor;
                  }
                  if (color !== '') {
                    treeFileName += '-' + color;
                  }
                  if (presents !== '') {
                    treeFileName += '-' + presents;
                  }

                  arrPreviews.forEach(preview => {
                    if (preview.slug === treeFileName) {
                      const previewNoImg = treePreview.querySelector('.g-configurator--preview--noimage');
                      const previewPic = treePreview.querySelector('.g-configurator--preview--pic');
                      const previewImg = treePreview.querySelector('.g-configurator--preview--img');

                      if (previewPic) {
                        previewNoImg.classList.add('is-hidden');
                        previewPic.classList.add('is-changing');

                        setTimeout(() => {
                          [...previewPic.querySelectorAll('source')].forEach(source => {
                            if (source.media.includes('360px')) {
                              source.srcset = source.dataset.srcset = preview.sizes[360];
                            }
                            if (source.media.includes('768px')) {
                              source.srcset = source.dataset.srcset = preview.sizes[768];
                            }
                            if (source.media.includes('1344px')) {
                              source.srcset = source.dataset.srcset = preview.sizes[1344];
                            }
                            if (source.media.includes('1920px')) {
                              source.srcset = source.dataset.srcset = preview.sizes[1920];
                            }
                          });

                          previewImg.src = preview.url;
                          previewPic.classList.remove('is-changing');
                        }, 300);

                        const previewMblBtnLbl = document.querySelector('.g-configurator--preview--btn span');

                        if (target.name === 'tree_type[]' || target.name === 'tree_color[]') {
                          previewMblBtnLbl.classList.remove('is-hidden');

                          setTimeout(() => {
                            previewMblBtnLbl.classList.add('is-hidden');
                          }, 5000);
                        }
                      }
                    }
                  });
                }
              }
            }
          }
        }

        // Step 3 prices
        if (
          target.classList.contains('g-configurator--checkbox') &&
          target.name === 'tree_size[]' &&
          target.dataset.decor
        ) {
          const app_url = document.querySelector('meta[name=app_url]')
            ? document.querySelector('meta[name=app_url]').content
            : null;
          const decor = target.dataset.decor.split(',');

          decor.forEach(attr => {
            if (attr === 'undecorated') {
              this.data.tree.step_3_prices.undecorated = `£${target.dataset.price}`;
            }

            if (attr === 'lights-only' || attr === 'decorated' || attr === 'double-decorations') {
              document.body.classList.add('is-loading');

              let attr_pa_battery = 'no';
              if (['9ft', '10ft', '12ft', '14ft'].some(size => target.dataset.slug.includes(size))) {
                attr_pa_battery = 'not-applicable';
              }

              fetch(`${app_url}/routes/variations`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify({
                  product_id: target.value,
                  attributes: [
                    { 'attribute_pa_decorations-lights': attr },
                    { attribute_pa_battery: attr_pa_battery },
                    {
                      attribute_pa_colour:
                        (attr === 'decorated' || attr === 'double-decorations')
                          ? 'santa-s-secret'
                          : 'not-applicable',
                    },
                    { 'attribute_pa_decorative-presents': 'no-just-the-basic' },
                  ],
                }),
              })
                .then(response => response.json())
                .then(data => {
                  this.data.tree.step_3_prices[
                    attr.replaceAll('-', '_')
                  ] = `£${new Intl.NumberFormat("en", { minimumFractionDigits: 2 }).format(data.variation_price)}`;

                  document.body.classList.remove('is-loading');
                })
                .catch(error => {
                  console.error('Error:', error);
                });
            }

            if (attr === 'ice-white' || attr === 'warm-white') {
              this.data.tree.step_3_prices[
                attr.replaceAll('-', '_')
              ] = `£${target.dataset.price}`;
            }
          });
        }

        // Add to cart
        if (target.classList.contains('js--add-to-cart')) {
          const product = target.dataset.product;
          let step = Number(target.dataset.step);
          let substep = Number(target.dataset.substep);
          const alertMessages = JSON.parse(target.dataset.alerts);

          let attributes = [];
          let c_bespoke = null;

          target.blur();

          document.body.classList.add('is-loading');

          // if (this.data[product].attributes.size) {
          //   attributes.push({
          //     attribute_pa_size:
          //       this.data[product].attributes.size.slug || 'not-applicable',
          //   });
          // }

          if (this.data[product].attributes.decor) {
            attributes.push({
              'attribute_pa_decorations-lights':
                this.data[product].attributes.decor.slug || 'not-applicable',
            });
          }
          if (this.data[product].attributes.battery) {
            attributes.push({
              attribute_pa_battery:
                this.data[product].attributes.battery.slug || 'not-applicable',
            });
          }
          if (this.data[product].attributes.color) {
            attributes.push({
              attribute_pa_colour:
                this.data[product].attributes.color.slug || 'not-applicable',
            });
          }
          if (this.data[product].attributes.presents) {
            attributes.push({
              'attribute_pa_decorative-presents':
                this.data[product].attributes.presents.slug || 'no-just-the-basic',
            });
          }

          if (this.data[product].attributes.c_bespoke) {
            if ([...this.data[product].attributes.c_bespoke.name].length) {
              c_bespoke = [
                ...this.data[product].attributes.c_bespoke.name,
              ].join(', ');
            }
          }

          addToCart(
            this.data[product].type,
            this.data[product].attributes.size.id,
            attributes,
            c_bespoke,
            this.data[product].quantity,
            () => {
              setSteps([]);
              resetAttribute(null, this.data[product].attributes);

              if (step === 2) {
                if (document.body.dataset.nextStep) {
                  step = Number(document.body.dataset.nextStep);
                }
                if (document.body.dataset.nextSubstep) {
                  substep = Number(document.body.dataset.nextSubstep);
                }
              }

              Alpine.store('configurator', {
                step: step,
                substep: substep,
              });

              window.history.pushState(
                {},
                '',
                `?form=configurator&step=${step}&substep=${substep}`
              );

              // scrollToElem(document.getElementById('pb-configurator'), 0, 100);

              msg.flash(alertMessages.valid, true);
            },
            () => {
              msg.flash(alertMessages.invalid, false);
            }
          );
        }

        // Goto step
        if (target.classList.contains('js--goto-step')) {
          let step = Number(target.dataset.step);
          let substep = Number(target.dataset.substep);

          target.blur();

          resetAttribute(null, this.data['tree'].attributes);
          resetAttribute(null, this.data['accessory'].attributes);

          if (
            [1, 2, 4, 5].includes(step) &&
            !document.body.classList.contains('has-cart')
          ) {
            updateMiniCart();
          }

          if (step === 2) {
            if (document.body.dataset.nextStep) {
              step = Number(document.body.dataset.nextStep);
            }
            if (document.body.dataset.nextSubstep) {
              substep = Number(document.body.dataset.nextSubstep);
            }
          }

          Alpine.store('configurator', {
            step: step,
            substep: substep,
          });

          window.history.pushState(
            {},
            '',
            `?form=configurator&step=${step}&substep=${substep}`
          );

          // scrollToElem(document.getElementById('pb-configurator'), 0, 100);
        }
      });
    },
  }));

  function setSteps(steps, activeSteps) {
    Object.entries(steps).forEach(([key, value]) => {
      if (activeSteps.includes(key)) {
        steps[key] = true;
      } else {
        steps[key] = false;
      }
    });
  }

  function setAttribute(checkbox, toSet) {
    const checkboxGroup = checkbox.closest('[data-group-checkboxes]');
    const checkboxSiblings = [
      ...checkboxGroup.querySelectorAll('.g-configurator--checkbox'),
    ];
    const multiCheckbox = parseInt(checkbox.dataset.multiCheckbox);
    const checkboxCount = parseInt(
      [...checkboxGroup.querySelectorAll('[data-multi-checkbox]:checked')]
        .length
    );

    if (multiCheckbox === 1) {
      toSet.id = checkbox.value;
      toSet.name = checkbox.dataset.name;
      toSet.slug = checkbox.dataset.slug;

      checkboxSiblings.forEach(item => {
        if (item !== checkbox && item.checked) {
          item.checked = false;
        }
      });
    }

    if (multiCheckbox > 1) {
      if (checkboxCount <= multiCheckbox) {
        toSet.id.push(checkbox.value);
        toSet.name.push(checkbox.dataset.name);
        toSet.slug.push(checkbox.dataset.slug);

        if (checkboxCount === multiCheckbox) {
          checkboxSiblings.forEach(item => {
            if (item !== checkbox && !item.checked) {
              item.disabled = true;
            }
          });
        }
      } else {
        checkboxSiblings.forEach(item => {
          if (item !== checkbox && !item.checked) {
            item.disabled = true;
          }
        });
      }
    }
  }

  function resetAttribute(checkbox = null, attributes, toReset = []) {
    Object.entries(attributes).forEach(([key, value]) => {
      if (!toReset.includes(key)) {
        if (typeof attributes[key].name === 'object') {
          if (checkbox) {
            if (key === checkbox.dataset.stepCurrent) {
              const indexId = attributes[key].id.indexOf(checkbox.value);
              const indexName = attributes[key].name.indexOf(
                checkbox.dataset.name
              );
              const indexSlug = attributes[key].slug.indexOf(
                checkbox.dataset.slug
              );

              if (indexId > -1) {
                attributes[key].id.splice(indexId, 1);
              }
              if (indexName > -1) {
                attributes[key].name.splice(indexName, 1);
              }
              if (indexSlug > -1) {
                attributes[key].slug.splice(indexSlug, 1);
              }
            } else {
              attributes[key].id = [];
              attributes[key].name = [];
              attributes[key].slug = [];
            }

            const checkboxGroup = checkbox.closest('[data-group-checkboxes]');
            const checkboxSiblings = [
              ...checkboxGroup.querySelectorAll('.g-configurator--checkbox'),
            ];
            const multiCheckbox = parseInt(checkbox.dataset.multiCheckbox);
            const checkboxCount = parseInt(
              [
                ...checkboxGroup.querySelectorAll(
                  '[data-multi-checkbox]:checked'
                ),
              ].length
            );

            if (multiCheckbox > 1 && checkboxCount < multiCheckbox) {
              checkboxSiblings.forEach(item => {
                item.disabled = false;
              });
            }
          } else {
            attributes[key].id = [];
            attributes[key].name = [];
            attributes[key].slug = [];
          }
        } else {
          attributes[key].id = 0;
          attributes[key].name = '';
          attributes[key].slug = '';

          const nextStepsCheckboxes = document.querySelectorAll(
            `[data-step-current="${key}"]`
          );

          if (nextStepsCheckboxes) {
            nextStepsCheckboxes.forEach(checkbox => {
              checkbox.checked = false;
            });
          }
        }
      }
    });
  }

  function scrollToNextStep(checkbox, stepNext, callback) {
    const checkboxGroup = checkbox.closest('[data-group-checkboxes]');
    const multiCheckbox = parseInt(checkbox.dataset.multiCheckbox);
    const checkboxCount = parseInt(
      [...checkboxGroup.querySelectorAll('[data-multi-checkbox]:checked')]
        .length
    );

    if (checkboxCount === multiCheckbox) {
      setTimeout(() => {
        // scrollToElem(
        //   document.querySelector(`#step-${stepNext}`),
        //   document.querySelector('.g-configurator--breadcrumbs').offsetHeight ||
        //     0
        // );

        callback();
      }, 100);
    }
  }

  function setPrice(product, attributes) {
    if (product.step.summary) {
      if (product.type === 'variation') {
        product.quantity = 1;
        product.subtotal = 0;
        product.total = 0;

        document.body.classList.add('is-loading');

        const app_url = document.querySelector('meta[name=app_url]')
          ? document.querySelector('meta[name=app_url]').content
          : null;

        let attrs = [];

        if (attributes.decor) {
          attrs.push({
            'attribute_pa_decorations-lights':
              attributes.decor.slug || 'not-applicable',
          });
        }
        if (attributes.battery) {
          attrs.push({
            attribute_pa_battery: attributes.battery.slug || 'not-applicable',
          });
        }
        if (attributes.color) {
          attrs.push({
            attribute_pa_colour: attributes.color.slug || 'not-applicable',
          });
        }
        if (attributes.presents) {
          attrs.push({
            'attribute_pa_decorative-presents':
              attributes.presents.slug || 'no-just-the-basic',
          });
        }

        fetch(`${app_url}/routes/variations`, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          redirect: 'follow',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify({
            product_id: attributes.size.id,
            attributes: attrs,
          }),
        })
          .then(response => response.json())
          .then(data => {
            const price = Number(data.variation_price);
            const quantity = Number(product.quantity);

            product.subtotal = price
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,');
            product.total = (price * quantity)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,');

            document.body.classList.remove('is-loading');
          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        product.quantity = 1;
        product.total = 0;

        const price = Number(product.subtotal);
        const quantity = Number(product.quantity);

        product.subtotal = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        product.total = (price * quantity)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }
    }
  }

  function cartHasTrees(data) {
    document.body.classList.add('is-loading');

    fetch('/ajax-cart/')
      .then(response => response.text())
      .then(html => {
        // Has real trees
        const preferredDelivery = document.getElementById(
          'form-configurator-preferred-delivery'
        );

        if (preferredDelivery) {
          const tooEarlyWillDie = document.getElementById('too-early-will-die');

          if (html.includes('Real Tree')) {
            preferredDelivery.querySelector(
              'option:nth-child(2)'
            ).disabled = true;
            tooEarlyWillDie.classList.remove('hide-all');
          } else {
            preferredDelivery.querySelector(
              'option:nth-child(2)'
            ).disabled = false;
            tooEarlyWillDie.classList.add('hide-all');
          }
        }

        // Has any tree
        const htmlDom = new DOMParser().parseFromString(html, 'text/html');
        const realTrees = [
          ...htmlDom.querySelectorAll('[data-type="Real Tree"]'),
        ];
        const artificialTrees = [
          ...htmlDom.querySelectorAll('[data-type="Artificial Tree"]'),
        ];
        const coneTrees = [
          ...htmlDom.querySelectorAll('[data-type="Cone Tree"]'),
        ];
        const littleTrees = [
          ...htmlDom.querySelectorAll('[data-type="‘Little’ Tree"]'),
        ];
        const UncategorizedProduct = [
          ...htmlDom.querySelectorAll('[data-type="Uncategorized"]'),
        ];

        if (
          realTrees.length ||
          artificialTrees.length ||
          coneTrees.length ||
          UncategorizedProduct.length
        ) {
          data.has_tree = 'Yes';
        }

        if (littleTrees.length) {
          data.has_little_tree = 'Yes';
        }
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {
        document.body.classList.remove('is-loading');
      });
  }

  window.addEventListener('click', event => {
    if (event.target.classList.contains('js--configurator--preview-trigger')) {
      document.querySelector('.js--configurator--preview-wrapper').classList.toggle('is-active');
    }
  });
};
